import React from "react";
import "./Styles/Pages/modal.scss";

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.modalContent = React.createRef();
    this.state = {};
  }

  insertHtmlElement(htmlString) {
    return { __html: htmlString };
  }

  componentDidMount() {
    // document.addEventListener("mousedown", this.captureClick, false);
    if (!this.props.preventEsc) {
      document.addEventListener("keydown", this.captureEscape, false);
    }

    if (this.modalContent.current) {
      this.modalContent.current.focus();
    }

    if (this.props.position || this.props.closeOnOutsideClick) {
      document.addEventListener("mousedown", this.captureClick, false);
    }
    document.querySelector("body").style.overflowY = "hidden";
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.captureClick, false);
    document.removeEventListener("keydown", this.captureEscape, false);
    document.querySelector("body").style.overflowY = "auto";
  }

  componentDidUpdate(prevProps) {
    if (prevProps.maxHeight !== this.props.maxHeight) {
      if (this.props.maxHeight === "none") {
        document.querySelector("body").style.overflowY = "auto";
      } else {
        document.querySelector("body").style.overflowY = "hidden";
      }
    }
  }

  captureEscape = (e) => {
    if (e.keyCode === 27 && this.props.closeModal && !this.props.preventClose) {
      this.props.closeModal();
    }
  };

  captureClick = (e) => {
    if (this.modalContent.current) {
      if (this.modalContent.current.contains(e.target)) {
        return;
      }
      this.props.closeModal();
    }
  };

  render() {
    return (
      <div
        className="bo-modal showmodal"
        style={{ background: this.props.isLight ? "rgba(0,0,0,0.2)" : "" }}
      >
        <div
          className={`bo-modal-body ${
            this.props.isSmall
              ? "smallscreen"
              : this.props.isInvoice
              ? "invoiceFullScreen"
              : "fullscreen"
          } ${this.props.position || ""} ${
            this.props.isFullScreenWeb && "fullscreen-web"
          }`}
          style={{ width: this.props.width ? this.props.width : "" }}
          ref={this.modalContent}
          tabIndex={0}
        >
          {this.props.header && (
            <div className="bo-modal-body-header">
              <div
                className={`bo-modal-body-header-title ${
                  this.props.subheader && "no-flex"
                }`}
                style={
                  this.props.truncheader && {
                    width: "calc(100% - 30px)",
                    marginRight: "15px",
                  }
                }
              >
                {this.props.goBack && (
                  <span className="go-back" onClick={this.props.goBack}>
                    <span>
                      <img src="Images/dark-back.svg" alt="" />
                    </span>
                  </span>
                )}
                <div
                  className={this.props.truncheader && "trunc"}
                  dangerouslySetInnerHTML={this.insertHtmlElement(
                    this.props.header
                  )}
                />
                {this.props.subTag && (
                  <span>
                    <div className="paylater">{this.props.tagText}</div>
                  </span>
                )}
                {this.props.subheader && <p>{this.props.subheader}</p>}
              </div>

              {!this.props.preventClose && (
                <div
                  className="bo-modal-body-header-close no-print"
                  onClick={this.props.closeModal}
                >
                  <span>×</span>
                </div>
              )}
            </div>
          )}
          {this.props.isHeaderClose && (
            <div
              className="bo-modal-body-header"
              style={{ borderBottom: "0px", padding: "0px 20px 0px" }}
            >
              <div
                className={`bo-modal-body-header-title ${
                  this.props.subheader && "no-flex"
                }`}
              ></div>

              <div
                className="bo-modal-body-header-close no-print"
                onClick={this.props.closeModal}
              >
                <span>×</span>
              </div>
            </div>
          )}
          <div
            className="bo-modal-body-content"
            style={{
              paddingTop: this.props.isHeaderClose ? "0px" : "",
              maxHeight:
                (window.screen.width > 1124 ||
                  this.props.forceMobileMaxHeight) &&
                this.props.maxHeight
                  ? this.props.maxHeight
                  : "",
              minHeight:
                window.screen.width > 1124 && this.props.minHeight
                  ? this.props.minHeight
                  : "",
              width:
                window.screen.width > 1124 && this.props.width
                  ? this.props.width
                  : "",
            }}
          >
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
